'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { isPublicMarketingPath } from '@/lib/appRoutes';
import { captureFirstTouch } from '@/lib/attribution';

/**
 * Records the first public page of a visit, so the contact form can report
 * which page earned the enquiry. All of the reasoning lives in
 * src/lib/attribution.ts; this is only the mount point.
 *
 * Mounted in the root layout beside GoogleAnalytics and gated by the same
 * predicate: a signed-in builder moving around their own ERP has no marketing
 * first touch to record, and their URLs carry tenant record ids. The capture is
 * first-write-wins, so the gate also means a session that starts inside the app
 * cannot stamp a private path as somebody's landing page.
 *
 * Renders nothing.
 */
export default function AttributionCapture() {
  const pathname = usePathname() || '/';

  useEffect(() => {
    if (!isPublicMarketingPath(pathname)) return;
    captureFirstTouch(pathname);
  }, [pathname]);

  return null;
}
